import { getLandingUrlFromPath } from '@doltech/utils/lib/url';
import * as React from 'react';

import { LandingBlogItemModel } from '../../../figma/Blog/models/LandingBlogModel';
import {
  StructuralCard,
  StructuralItemLayout,
} from '../../../figma/Card/DolCard/TextOnlyCard/StructuralCard';
import { useFromScreens } from '../../../hooks/useDeviceQuery.hook';

export interface RelatedPostCardModel extends LandingBlogItemModel {}

export interface RelatedPostCardProps {
  data: RelatedPostCardModel;
}

export const RelatedPostCard = (props: RelatedPostCardProps) => {
  const { data } = props;
  const { title, description, thumbnail } = data;
  const url = getLandingUrlFromPath(data.url, 'landing-blog-detail');
  const [, from776] = useFromScreens([0, 776]);

  const imageProps = React.useMemo(() => {
    if (from776) {
      return {
        width: 186,
        ratio: 3 / 2,
      };
    }
    return {
      ratio: 1,
      width: 58,
    };
  }, [from776]);

  const structuralCardItems: StructuralItemLayout[] = React.useMemo(() => {
    return [
      {
        dataIndex: 'card-main',
        direction: 'horizontal',
        gridTemplate: {
          areas: '"image card-content"',
          columns: 'max-content minmax(0, 1fr)',
          gap: [24, 24],
          alignItems: 'center',
        },
        items: [
          {
            dataIndex: 'card-content',
            direction: 'vertical',
            gridTemplate: {
              gap: [8, 8],
              areas: `
              "title"
              "description"`,
            },
            items: [
              {
                dataIndex: 'title',
                type: 'TITLE',
                defaultProps: {
                  children: title,
                  prefetch: false,
                  url,
                },
              },
              {
                dataIndex: 'description',
                type: 'DESCRIPTION',
                defaultProps: {
                  children: description,
                },
              },
            ],
          },
          {
            dataIndex: 'image',
            type: 'IMAGE',
            defaultProps: {
              url,
              imageUrl: thumbnail?.url,
              alt: thumbnail?.alt || title,
              prefetch: false,
              ...imageProps,
            },
          },
        ],
      },
    ];
  }, [description, imageProps, thumbnail?.alt, thumbnail?.url, title, url]);
  return <StructuralCard className="related-post-card" items={structuralCardItems} />;
};
